'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var buildErrorMetaObject = exports.buildErrorMetaObject = function buildErrorMetaObject(_ref) {
  var _ref$ignore = _ref.ignore,
      ignore = _ref$ignore === undefined ? false : _ref$ignore,
      message = _ref.message,
      _ref$silent = _ref.silent,
      silent = _ref$silent === undefined ? false : _ref$silent,
      titleText = _ref.titleText,
      _ref$displayEventId = _ref.displayEventId,
      displayEventId = _ref$displayEventId === undefined ? true : _ref$displayEventId;
  return {
    error: {
      ignore: ignore,
      message: message,
      silent: silent,
      titleText: titleText,
      displayEventId: displayEventId
    }
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/action/lib/buildErrorMetaObject.js
// module id = 824
// module chunks = 2 3